import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';
import './CommuneDetail.css';

interface Project {
  id: number;
  name: string;
  object?: string;
  created_at: string;
}

interface CommuneDetailProps {
  communeId: number;
  communeName: string;
  onSelectProject: (projectId: number, projectName: string) => void;
  onCreateProject: (communeId: number, communeName: string) => void;
}

const CommuneDetail: React.FC<CommuneDetailProps> = ({ 
  communeId, 
  communeName, 
  onSelectProject,
  onCreateProject 
}) => {
  const [projects, setProjects] = useState<Project[]>([]);

  useEffect(() => {
    loadProjects();
  }, [communeId]);

  const loadProjects = async () => {
    try {
      const response = await fetch(`${API_URL}/projects?commune=${communeName}`);
      const data = await response.json();
      setProjects(data);
    } catch (error) {
      console.error('Error loading projects:', error);
    }
  };

  return (
    <div className="commune-detail">
      <div className="commune-header">
        <h1>🏘️ {communeName}</h1>
        <button onClick={() => onCreateProject(communeId, communeName)} className="btn-add">
          ➕ Nouveau Projet
        </button>
      </div>

      <div className="projects-section">
        <h2>Projets ({projects.length})</h2>
        
        {projects.length > 0 ? (
          <div className="projects-list">
            {projects.map(project => (
              <div
                key={project.id}
                className="project-item"
                onClick={() => onSelectProject(project.id, project.name)}
              >
                <div className="project-info">
                  <h3>{project.name}</h3>
                  {project.object && <p>{project.object}</p>}
                </div>
                <div className="project-date">
                  {new Date(project.created_at).toLocaleDateString('fr-FR')}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-projects">
            <p>Aucun projet pour cette commune</p>
            <button onClick={() => onCreateProject(communeId, communeName)} className="btn-primary">
              Créer le premier projet
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommuneDetail;
